import { useSearchParams } from 'react-router-dom';
import { useCompanies } from '../api/companies.js';
import CompaniesPanel from '../components/panels/CompaniesPanel.jsx';
import ProcessesPanel from '../components/panels/ProcessesPanel.jsx';
import ExecutionsPanel from '../components/panels/ExecutionsPanel.jsx';
import PaymentsPanel from '../components/panels/PaymentsPanel.jsx';

export default function WorkspacePage() {
    const [searchParams, setSearchParams] = useSearchParams();
    const companyId = searchParams.get('companyId') ?? undefined;
    const processId = searchParams.get('processId') ?? undefined;
    const executionId = searchParams.get('executionId') ?? undefined;

    const { data: companies } = useCompanies();
    const companyName = companies?.find((c) => c.id === companyId)?.name;

    function selectCompany(id) {
        setSearchParams({ companyId: id });
    }

    function selectProcess(id) {
        setSearchParams({ companyId, processId: id });
    }

    function selectExecution(id) {
        setSearchParams({ companyId, processId, executionId: id });
    }

    return (
        <div className="workspace">
            <CompaniesPanel selectedCompanyId={companyId} onSelect={selectCompany} />
            <div className="workspace-sidebar">
                <ProcessesPanel
                    companyId={companyId}
                    companyName={companyName}
                    selectedProcessId={processId}
                    onSelect={selectProcess}
                />
                <ExecutionsPanel
                    companyId={companyId}
                    processId={processId}
                    selectedExecutionId={executionId}
                    onSelect={selectExecution}
                />
            </div>
            <PaymentsPanel key={executionId} companyId={companyId} processId={processId} executionId={executionId} />
        </div>
    );
}
